import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { Collapse, Dropdown } from "react-bootstrap";
import { connect } from "react-redux";

class Sidebar extends Component {
  state = {};

  // ---------- permissions helpers ----------
  normalizePath = (p = "") => String(p).trim().toLowerCase();

  canAccess = (path) => {
    const { user } = this.props;
    if (!path || !user) return false;
    if (user.role === "admin") return true;
    const pages = Array.isArray(user.pages) ? user.pages : [];
    const target = this.normalizePath(path);
    return pages.some((p) => this.normalizePath(p) === target);
  };

  anyVisible = (paths = []) => paths.some((p) => this.canAccess(p));

  // ---------- ui helpers ----------
  toggleMenuState(menuState) {
    if (this.state[menuState]) {
      this.setState({ [menuState]: false });
    } else if (Object.keys(this.state).length === 0) {
      this.setState({ [menuState]: true });
    } else {
      Object.keys(this.state).forEach((i) => {
        this.setState({ [i]: false });
      });
      this.setState({ [menuState]: true });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.onRouteChanged();
    }
  }

  onRouteChanged() {
    const sidebar = document.querySelector("#sidebar");
    if (sidebar) sidebar.classList.remove("active");
    Object.keys(this.state).forEach((i) => {
      this.setState({ [i]: false });
    });

    const dropdownPaths = [
      { path: "/apps", state: "appsMenuOpen" },
      { path: "/basic-ui", state: "basicUiMenuOpen" },
      { path: "/support", state: "supportMenuOpen" },
      { path: "/finance", state: "financeMenuOpen" },
      { path: "/form-elements", state: "formElementsMenuOpen" },
      { path: "/tables", state: "tablesMenuOpen" },
      { path: "/icons", state: "iconsMenuOpen" },
      { path: "/charts", state: "chartsMenuOpen" },
      { path: "/user-pages", state: "userPagesMenuOpen" },
      { path: "/error-pages", state: "errorPagesMenuOpen" },
      { path: "/control", state: "basicUiMenuOpen" }, // ensure control group opens when visiting any /control route
    ];

    dropdownPaths.forEach((obj) => {
      if (this.isPathActive(obj.path)) {
        this.setState({ [obj.state]: true });
      }
    });
  }

  isPathActive(path) {
    const cur = this.normalizePath(this.props.location.pathname);
    return cur.startsWith(this.normalizePath(path));
  }

  componentDidMount() {
    this.onRouteChanged();
    // add class 'hover-open' to sidebar navitem while hover in sidebar-icon-only menu
    const body = document.querySelector("body");
    document.querySelectorAll(".sidebar .nav-item").forEach((el) => {
      el.addEventListener("mouseover", function () {
        if (body && body.classList.contains("sidebar-icon-only")) {
          el.classList.add("hover-open");
        }
      });
      el.addEventListener("mouseout", function () {
        if (body && body.classList.contains("sidebar-icon-only")) {
          el.classList.remove("hover-open");
        }
      });
    });
  }

  render() {
    // Define groups once; these must match AppRoutes paths (all lowercase)
    const SUPPORT_ITEMS = [
      "/support/verify-cash-orders",
      "/support/aramex",
      "/support/attendees-support",
      "/under-development", // Users Support placeholder
      "/support/refunds",
    ];

    const CONTROL_ITEMS = [
      "/control/website-book",
      "/control/new-orgs",
      "/under-development", // Edit Users placeholder
      "/control/send-top-picks",
      "/control/send-generic",
      "/control/send-notifications",
      "/control/export-users",
      "/control/send-whatsapp",
      "/control/pos-report",
    ];

    const FINANCE_ITEMS = [
      "/finance/events-by-name",
      "/finance/events-by-date",
      "/finance/org-data",
    ];

    const { user } = this.props;

    return (
      <nav className="sidebar sidebar-offcanvas" id="sidebar">
        <div className="sidebar-brand-wrapper d-none d-lg-flex align-items-center justify-content-center fixed-top">
          <a className="sidebar-brand brand-logo" href="index.html">
            TICK'IT
          </a>
          <a className="sidebar-brand brand-logo-mini" href="index.html">
            <img
              src={
                "https://tickit.co/_next/image?url=%2Fassets%2Fimages%2Flogo.png&w=256&q=75"
              }
              alt="logo"
            />
          </a>
        </div>
        <ul className="nav">
          <li className="nav-item profile">
            <div className="profile-desc">
              <div className="profile-pic">
                <div className="count-indicator">
                  <img
                    className="img-xs rounded-circle "
                    src="https://tickit.co/_next/image?url=%2Fassets%2Fimages%2Flogo.png&w=256&q=75"
                    alt="profile"
                  />
                  <span className="count bg-success"></span>
                </div>
                <div className="profile-name">
                  <h5 className="mb-0 font-weight-normal"></h5>
                  <span>
                    <p>{user?.role ? user.role : "User"}</p>
                  </span>
                </div>
              </div>
              <Dropdown alignRight>
                <Dropdown.Toggle as="a" className="cursor-pointer no-caret">
                  <i className="mdi mdi-dots-vertical"></i>
                </Dropdown.Toggle>
                <Dropdown.Menu className="sidebar-dropdown preview-list">
                  <a
                    href="!#"
                    className="dropdown-item preview-item"
                    onClick={(evt) => evt.preventDefault()}
                  >
                    <div className="preview-thumbnail">
                      <div className="preview-icon bg-dark rounded-circle">
                        <i className="mdi mdi-settings text-primary"></i>
                      </div>
                    </div>
                    <div className="preview-item-content">
                      <p className="preview-subject ellipsis mb-1 text-small">
                        <p>Account settings</p>
                      </p>
                    </div>
                  </a>
                  <div className="dropdown-divider"></div>
                  <a
                    href="!#"
                    className="dropdown-item preview-item"
                    onClick={(evt) => evt.preventDefault()}
                  >
                    <div className="preview-thumbnail">
                      <div className="preview-icon bg-dark rounded-circle">
                        <i className="mdi mdi-onepassword  text-info"></i>
                      </div>
                    </div>
                    <div className="preview-item-content">
                      <p className="preview-subject ellipsis mb-1 text-small">
                        <p>Change Password</p>
                      </p>
                    </div>
                  </a>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </li>

          <li className="nav-item nav-category">
            <span className="nav-link">
              <p>Navigation</p>
            </span>
          </li>

          {/* -------- Support -------- */}
          {this.anyVisible(SUPPORT_ITEMS) && (
            <li
              className={
                this.isPathActive("/support")
                  ? "nav-item menu-items active"
                  : "nav-item menu-items"
              }
            >
              <div
                className={
                  this.state.supportMenuOpen ? "nav-link menu-expanded" : "nav-link"
                }
                onClick={() => this.toggleMenuState("supportMenuOpen")}
                data-toggle="collapse"
              >
                <span className="menu-icon">
                  <i className="mdi mdi-headset"></i>
                </span>
                <span className="menu-title">
                  <p>Support</p>
                </span>
                <i className="menu-arrow"></i>
              </div>
              <Collapse in={this.state.supportMenuOpen}>
                <div>
                  <ul className="nav flex-column sub-menu">
                    {this.canAccess("/support/verify-cash-orders") && (
                      <li className="nav-item">
                        <Link
                          className={
                            this.isPathActive("/support/verify-cash-orders")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          to="/support/verify-cash-orders"
                        >
                          <p>Verify CashOrders</p>
                        </Link>
                      </li>
                    )}

                    {this.canAccess("/support/aramex") && (
                      <li className="nav-item">
                        <Link
                          className={
                            this.isPathActive("/support/aramex")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          to="/support/aramex"
                        >
                          <p>Verify Aramex CashOrders</p>
                        </Link>
                      </li>
                    )}

                    {this.canAccess("/support/attendees-support") && (
                      <li className="nav-item">
                        <Link
                          className={
                            this.isPathActive("/support/attendees-support")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          to="/support/attendees-support"
                        >
                          <p>Attendees Support</p>
                        </Link>
                      </li>
                    )}

                    {this.canAccess("/under-development") && (
                      <li className="nav-item">
                        <Link
                          className={
                            this.isPathActive("/under-development")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          to="/under-development"
                        >
                          <p>Users Support</p>
                        </Link>
                      </li>
                    )}

                    {this.canAccess("/support/refunds") && (
                      <li className="nav-item">
                        <Link
                          className={
                            this.isPathActive("/support/refunds")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          to="/support/refunds"
                        >
                          <p>Refunds</p>
                        </Link>
                      </li>
                    )}
                  </ul>
                </div>
              </Collapse>
            </li>
          )}

          {/* -------- Control -------- */}
          {this.anyVisible(CONTROL_ITEMS) && (
            <li
              className={
                this.isPathActive("/control")
                  ? "nav-item menu-items active"
                  : "nav-item menu-items"
              }
            >
              <div
                className={
                  this.state.basicUiMenuOpen ? "nav-link menu-expanded" : "nav-link"
                }
                onClick={() => this.toggleMenuState("basicUiMenuOpen")}
                data-toggle="collapse"
              >
                <span className="menu-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 24 24">
                    <path
                      fill="#f2a654"
                      d="M12 15.5A3.5 3.5 0 0 1 8.5 12A3.5 3.5 0 0 1 12 8.5a3.5 3.5 0 0 1 3.5 3.5a3.5 3.5 0 0 1-3.5 3.5m7.43-2.53c.04-.32.07-.64.07-.97c0-.33-.03-.66-.07-1l2.11-1.63c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.31-.61-.22l-2.49 1c-.52-.39-1.06-.73-1.69-.98l-.37-2.65A.506.506 0 0 0 14 2h-4c-.25 0-.46.18-.5.42l-.37 2.65c-.63.25-1.17.59-1.69.98l-2.49-1c-.22-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64L4.57 11c-.04.34-.07.67-.07 1c0 .33.03.65.07.97l-2.11 1.66c-.19.15-.25.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1.01c.52.4 1.06.74 1.69.99l.37 2.65c.04.24.25.42.5.42h4c.25 0 .46-.18.5-.42l.37-2.65c.63-.26 1.17-.59 1.69-.99l2.49 1.01c.22.08.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.66Z"
                    />
                  </svg>
                </span>
                <span className="menu-title">
                  <p>Control</p>
                </span>
                <i className="menu-arrow"></i>
              </div>
              <Collapse in={this.state.basicUiMenuOpen}>
                <div>
                  <ul className="nav flex-column sub-menu">
                    {this.canAccess("/control/website-book") && (
                      <li className="nav-item">
                        <Link
                          className={
                            this.isPathActive("/control/website-book")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          to="/control/website-book"
                        >
                          <p>Website Book</p>
                        </Link>
                      </li>
                    )}

                    {this.canAccess("/control/new-orgs") && (
                      <li className="nav-item">
                        <Link
                          className={
                            this.isPathActive("/control/new-orgs")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          to="/control/new-orgs"
                        >
                          <p>New Orgs</p>
                        </Link>
                      </li>
                    )}

                    {this.canAccess("/under-development") && (
                      <li className="nav-item">
                        <Link
                          className={
                            this.isPathActive("/under-development")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          to="/under-development"
                        >
                          <p>Edit Users</p>
                        </Link>
                      </li>
                    )}

                    {this.canAccess("/control/send-top-picks") && (
                      <li className="nav-item">
                        <Link
                          className={
                            this.isPathActive("/control/send-top-picks")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          to="/control/send-top-picks"
                        >
                          <p>Send Top Picks Email</p>
                        </Link>
                      </li>
                    )}

                    {this.canAccess("/control/send-generic") && (
                      <li className="nav-item">
                        <Link
                          className={
                            this.isPathActive("/control/send-generic")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          to="/control/send-generic"
                        >
                          <p>Send Generic</p>
                        </Link>
                      </li>
                    )}

                    {this.canAccess("/control/send-notifications") && (
                      <li className="nav-item">
                        <Link
                          className={
                            this.isPathActive("/control/send-notifications")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          to="/control/send-notifications"
                        >
                          <p>Send Notifications</p>
                        </Link>
                      </li>
                    )}

                    {this.canAccess("/control/export-users") && (
                      <li className="nav-item">
                        <Link
                          className={
                            this.isPathActive("/control/export-users")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          to="/control/export-users"
                        >
                          <p>Export Users</p>
                        </Link>
                      </li>
                    )}

                    {this.canAccess("/control/send-whatsapp") && (
                      <li className="nav-item">
                        <Link
                          className={
                            this.isPathActive("/control/send-whatsapp")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          to="/control/send-whatsapp"
                        >
                          <p>Send whatsapp</p>
                        </Link>
                      </li>
                    )}

                    {this.canAccess("/control/pos-report") && (
                      <li className="nav-item">
                        <Link
                          className={
                            this.isPathActive("/control/pos-report")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          to="/control/pos-report"
                        >
                          <p>Pos Report</p>
                        </Link>
                      </li>
                    )}
                  </ul>
                </div>
              </Collapse>
            </li>
          )}

          {/* -------- Finance -------- */}
          {this.anyVisible(FINANCE_ITEMS) && (
            <li
              className={
                this.isPathActive("/finance")
                  ? "nav-item menu-items active"
                  : "nav-item menu-items"
              }
            >
              <div
                className={
                  this.state.financeMenuOpen ? "nav-link menu-expanded" : "nav-link"
                }
                onClick={() => this.toggleMenuState("financeMenuOpen")}
                data-toggle="collapse"
              >
                <span className="menu-icon">
                  <i className="mdi mdi-chart-bar"></i>
                </span>
                <span className="menu-title">
                  <p>Finance</p>
                </span>
                <i className="menu-arrow"></i>
              </div>
              <Collapse in={this.state.financeMenuOpen}>
                <div>
                  <ul className="nav flex-column sub-menu">
                    {this.canAccess("/finance/events-by-name") && (
                      <li className="nav-item">
                        <Link
                          className={
                            this.isPathActive("/finance/events-by-name")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          to="/finance/events-by-name"
                        >
                          <p>Search Event By Name</p>
                        </Link>
                      </li>
                    )}

                    {this.canAccess("/finance/events-by-date") && (
                      <li className="nav-item">
                        <Link
                          className={
                            this.isPathActive("/finance/events-by-date")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          to="/finance/events-by-date"
                        >
                          <p>Search Event By Date</p>
                        </Link>
                      </li>
                    )}

                    {this.canAccess("/finance/org-data") && (
                      <li className="nav-item">
                        <Link
                          className={
                            this.isPathActive("/finance/org-data")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          to="/finance/org-data"
                        >
                          <p>Org gateway & fees</p>
                        </Link>
                      </li>
                    )}
                  </ul>
                </div>
              </Collapse>
            </li>
          )}
        </ul>
      </nav>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state?.auth?.user || null,
});

export default connect(mapStateToProps)(withRouter(Sidebar));